// values are limits of each device
export const MOBILE = 530;
export const PHABLET = 672;
export const TABLET = 1024;
export const DESKTOP_SM = 1200;
export const DESKTOP_MD = 1920;
export const DESKTOP_LG = 18200; // we don't want a limit here



// WEBPACK FOOTER //
// ./src/constants/screenSize.js